import * as R from 'ramda'
import React from 'react'
import { Link } from 'react-router'

let getDisplay = val => val.slice(val.indexOf('[') + 1, val.indexOf(']'))
let getID = val => val.slice(val.indexOf(':') + 1, val.indexOf(')'))
let getType = val => val.slice(val.indexOf('(') + 1, val.indexOf(':'))

export let plainText = val => {
	let mentionReg = /(@\[.*?\]\(.*?\))/g;
	let newLineReg = /(\n)/g;
	let splitReg = /(@\[.*?\]\(.*?\)|\n)/g;
	if(!val) return []
	val = val.split(splitReg)
	val = val.map((el, indx) => {
		if(el.match(mentionReg)) {
			return (
				<span key={indx}>
					{getDisplay(el)}
				</span>
			)
		} else if(el.match(newLineReg)){
			return <br key={indx} />
		} else {
			return (
				<span key={indx}>
					{' ' + el + ' '}
				</span>
			)
		}
	})
	return <span>{val}</span>
}

export let managersMentions = val =>{
	let regexp = /@\[.*?\]\(.*?\)/g
	let regexpLL = /!\[.*?\]\(.*?\)/g
	if(!val) return []
	let matches = val.match(regexp) || val.match(regexpLL)
	if(!matches) return []
	let managersIDs = []
	matches.forEach(x => (getType(x) == 'manager' || getType(x) == 'owner')? managersIDs.push(getID(x)) : "")
	return R.uniq(managersIDs)
}

export let linkedText = val => {
	let mentionReg = /(@\[.*?\]\(.*?\))/g;
	let newLineReg = /(\n)/g;
	let splitReg = /(@\[.*?\]\(.*?\)|\n)/g;
	if(!val) return []
	val = val.split(splitReg)
	val = val.map((el, indx) => {
		if(el.match(mentionReg)) {
			return (
				<Link
					key={indx}
					to={'/manager/' + getType(el) + '/' + getID(el)}
				>
					{getDisplay(el)}
				</Link>
			)
		} else if(el.match(newLineReg)){
			return <br key={indx} />
		} else {
			return (
				<span key={indx}>
					{' ' + el + ' '}
				</span>
			)
		}
	})
	return <p>{val}</p>
}
export let commentText = val => {
	let mentionReg = /(@\[.*?\]\(.*?\))/g;
	let newLineReg = /(\n)/g;
	let splitReg = /(@\[.*?\]\(.*?\)|\n)/g;
	if(!val) return []
	val = val.split(splitReg)
	val = val.map((el, indx) => {
		if(el.match(mentionReg)) {
			return ""
		} else if(el.match(newLineReg)){
			return ""
		} else {
			return el
		}
	})
	val = val.join('')
	return val
}



// WEBPACK FOOTER //
// ./src/utils/commentsText.js